export default "__VITE_ASSET__c71ae461__"